//comissao geral
export function calcCommissionGeral(percentage, valueLand) {
  return (percentage * valueLand) / 100;
}
//multiplica o valor da comissao pela quantidade de parcelas
export const handleMultipliesCommission = (valueCommission, quantity) => {
  const value = valueCommission !== undefined ? valueCommission : 1;
  if (quantity > 0) {
    return value * quantity;
  }
  return value;
};
//porcentagem da imobliaria sem a porcentagem dos corretores (imob sempre pega 100% da comissao geral)
export function calcPercentageImobWithoutBrokers(PercentageBrokers) {
  return 100 - PercentageBrokers;
}
// Calcula o valor sobre a porcentagem da imobiliaria sem a porcentagem dos corretores
export function calcValueImobWithoutBrokers(
  valueCommissionGeral,
  PercentageBrokers
) {
  return (
    (calcPercentageImobWithoutBrokers(PercentageBrokers) *
      valueCommissionGeral) /
    100
  );
}
